import './components.scss';

const PageBody = (props) => {
    return (
      <div className="pageBody">
        {props.children}
      </div>
    )
  }

  export default PageBody;